import { Box, Container, Grid, makeStyles, Paper, Typography, Link, Hidden } from "@material-ui/core";
import React, { useEffect } from "react";
import { colors } from "swyft-react-core";
import { ReviewContainer } from "../quotePage/ReviewContainer";
import { Link as RouterLink, useHistory } from "react-router-dom";
import DoneIcon from "@material-ui/icons/Done";
import { QuoteGuarantee } from "../quotePage/QuoteGuarantee";
import { EQuoteType } from "../../api/Types";
import { EEventType, eventAnalytic } from "../../app/analytics";
import OverrideTheme from "../../components/OverrideTheme";

const useStyles = makeStyles((theme) => ({
  root: {},
  alternate: {
    background: colors.alternate
  },
  button: {
    width: "90%",
    maxWidth: "17.5rem"
  },
  banner: {
    "backgroundSize": "cover",
    "backgroundPosition": "center",
    "width": "100%",
    "display": "flex",
    "alignItems": "center",
    "height": "140px",
    "backgroundImage": "url(images/sm/img-header-servicing.jpg)",
    [theme.breakpoints.up("sm")]: {
      height: "210px"
    },
    [theme.breakpoints.up("md")]: {
      backgroundImage: "url(images/md/img-header-servicing.jpg)",
      height: "400px"
    },
    [theme.breakpoints.up("lg")]: {
      backgroundImage: "url(images/lg/img-header-servicing.jpg)"
    },
    [theme.breakpoints.up("xl")]: {
      backgroundImage: "url(images/xl/img-header-servicing.jpg)"
    },
    '& [class*="Container-root"]': {
      display: "flex"
    }
  },
  images: {
    display: "flex",
    height: "180px",
    margin: "auto",
    [theme.breakpoints.down("md")]: {
      height: "107px"
    }
  },
  doubleButton: {
    '& [class*="Button-root"]': {
      minWidth: "10rem",
      padding: "6px 8px",
      width: "auto"
    }
  },
  mb: {
    [theme.breakpoints.up("md")]: {
      marginBottom: theme.spacing(3)
    }
  },
  list: {
    "maring": "0px",
    "padding": "0px",
    "paddingLeft": theme.spacing(2),
    "& li": {
      marginTop: theme.spacing(2)
    },
    "& li::marker": {
      color: colors.secondary
    }
  },
  listCheck: {
    "listStyle": "none",
    "margin": "0px",
    "padding": "0px",
    "& li": {
      "display": "flex",
      "marginTop": theme.spacing(2),
      '& [class*="SvgIcon-root"]': {
        display: "flex",
        verticalAlign: "sub",
        marginRight: theme.spacing(1),
        [theme.breakpoints.down("md")]: {
          verticalAlign: "bottom",
          marginRight: theme.spacing(2)
        }
      },
      [theme.breakpoints.down("md")]: {
        marginTop: "0px"
      }
    }
  }
}));

const strings = {
  "protect.header": "Swyft Boiler Servicing",
  "protect.header.sub.1": "from ",
  "protect.header.sub.2": "€8.99",
  "protect.header.sub.3": " per month",
  "protect.section.1.header": "We've got you covered.",
  "protect.section.1.p.1":
    "In order to keep the warranty active, a service needs to carried out every year by an RGII registered engineer. We have a cover plan that is hassle free every year and ensures your boiler is running safely and efficiently.",

  "protect.section.2.header": "Swyft Boiler Servicing ",
  "protect.section.2.p.1": "Your Swyft Boiler Servicing package includes all the benefits of",
  "protect.section.3.list.1": [
    "Annual boiler service",
    "Our extensive 20 Point Service",
    "12 easy monthly payments of just €8.99",
    "Remote Video Call Support "
  ],
  "protect.section.3.list.2": [
    "Priority Call Out",
    "Warranty Contact Support",
    "RGII Certificate of Compliance",
    "€200 solar installation voucher"
  ],

  "protect.section.3.header": "How it works",
  "protect.section.3.p.1":
    "Sign up today and 1 day after the deposit has been paid, we will activate your subscription of €8.99 every month.",
  "protect.section.3.p.2": "It's that simple!",
  "protect.section.3.p.3":
    "If you would like to find out more about our Swyft Boiler Servicing, please contact us by email at",
  "protect.section.3.p.4": "or by phone on",
  "protect.section.3.p.5": "You can also access our full",
  "protect.section.3.button.terms": "Terms & Conditions",

  "protect.section.4.header": "Swyft 20 Point",
  "protect.section.4.sub": "Service Check",
  "protect.section.4.list.1": [
    "Check the location of the appliance, its condition and electrical controls.",
    "Inspect flue thoroughly.",
    "Check ventilation meets legal requirements.",
    "Conduct electrical safety tests.",
    "Check accessibility, functionality, and condition of isolating valves.",
    "Inspect/clean fan unit and evaluate performance and functionality.",
    "Inspect/clean heat exchanger as per manufacturer’s instructions.",
    "Inspect/clean/adjust main and pilot burners and injectors.",
    "Check/clean/adjust ignition and ionisation electrodes.",
    "Check flame picture."
  ],
  "protect.section.4.list.2": [
    "Check temperature control.",
    "Check operation of boiler safety devices.",
    "Check appliance gas rating.",
    "Conduct burner pressure tests.",
    "Sample air intake analysis",
    "Sample flue gas analysis to ensure safe operation.",
    "Conduct appliance gas safety tests.",
    "Adjustment time and temperature controls as required",
    "Copy of RGII appliance conformance certificate",
    "Clean up."
  ],

  "protect.section.5.header": "Swyft Guarantee",
  "protect.section.5.sub.1": "Swyft Energy Happiness Guarantee",
  "protect.section.5.sub.2": "Swyft Energy 12 Month Worksmanship Guarantee",
  "protect.section.5.sub.3": "We work with the very best local RGII registered engineers in your area"
};

const sectionOne = (
  <Box textAlign="center">
    <Typography variant="h3" paragraph>
      {strings["protect.section.1.header"]}
    </Typography>
    <Typography variant="body1" paragraph>
      {strings["protect.section.1.p.1"]}
    </Typography>
  </Box>
);

const sectionTwo = (classes: any) => (
  <Box>
    <Paper elevation={3}>
      <Box p={3}>
        <Grid container justifyContent="center">
          <Grid item md={4} xs={12}>
            <Hidden mdDown>
              <Box textAlign="center">
                <img className={classes.images} src="images/servicing/icon-boiler.png" alt="boiler" />
                <Typography variant="body1">{strings["protect.header.sub.1"]}</Typography>
                <Typography variant="h5">{strings["protect.header.sub.2"]}</Typography>
                <Typography variant="body1">{strings["protect.header.sub.3"]}</Typography>
              </Box>
            </Hidden>
            <Hidden lgUp>
              <Grid container>
                <Grid item xs={4}>
                  <img className={classes.images} src="images/servicing/icon-boiler.png" alt="boiler" />
                </Grid>
                <Grid item xs={8}>
                  <Box textAlign="center" pt={2}>
                    <Typography variant="body1">{strings["protect.header.sub.1"]}</Typography>
                    <Typography variant="h5">{strings["protect.header.sub.2"]}</Typography>
                    <Typography variant="body1">{strings["protect.header.sub.3"]}</Typography>
                  </Box>
                </Grid>
              </Grid>
            </Hidden>
          </Grid>
          <Grid item md={8} xs={12}>
            <Box mt={3}>
              <Typography variant="h2" paragraph>
                {strings["protect.section.2.header"]}
              </Typography>
            </Box>
            <Box mt={3}>
              <Typography variant="h4" paragraph>
                {strings["protect.section.2.p.1"]}
              </Typography>
            </Box>
            <Hidden mdDown>
              <Grid container spacing={1}>
                <Grid item md={6} xs={12}>
                  <ul className={classes.list}>
                    {strings["protect.section.3.list.1"].map((i, index) => (
                      <li key={index}>
                        <Typography variant="body1">{i}</Typography>
                      </li>
                    ))}
                  </ul>
                </Grid>
                <Grid item md={6} xs={12}>
                  <ul className={classes.list}>
                    {strings["protect.section.3.list.2"].map((i, index) => (
                      <li key={index}>
                        <Typography variant="body1">{i}</Typography>
                      </li>
                    ))}
                  </ul>
                </Grid>
              </Grid>
            </Hidden>
            <Hidden lgUp>
              <Box>
                <ul className={classes.list}>
                  {strings["protect.section.3.list.1"].map((i, index) => (
                    <li key={index}>
                      <Typography variant="body1">{i}</Typography>
                    </li>
                  ))}
                  {strings["protect.section.3.list.2"].map((i, index) => (
                    <li key={index}>
                      <Typography variant="body1">{i}</Typography>
                    </li>
                  ))}
                </ul>
              </Box>
            </Hidden>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  </Box>
);

const sectionThree = (
  <Box>
    <Grid container spacing={3}>
      <Hidden lgUp>
        <Grid item xs={12}>
          <img width="100%" src="images/servicing/services.jpg" alt="servicing" />
        </Grid>
      </Hidden>
      <Grid item md={6} xs={12}>
        <Typography variant="h3" paragraph>
          {strings["protect.section.3.header"]}
        </Typography>
        <Typography variant="body1">{strings["protect.section.3.p.1"]}</Typography>
        <Typography variant="body1" paragraph>
          {strings["protect.section.3.p.2"]}
        </Typography>
        <Typography variant="body1" paragraph>
          {strings["protect.section.3.p.3"]}&nbsp;
          <Box component="span" fontWeight="fontWeightBold">
            <Link href="mailto:operations@swyftenergy.ie">operations@swyftenergy.ie</Link>
          </Box>
          <Typography variant="body1" component="span">
            &nbsp;{strings["protect.section.3.p.4"]}
            &nbsp;
            <Box component="span" fontWeight="fontWeightBold">
              (01) 504 2111
            </Box>
          </Typography>
        </Typography>

        <Typography variant="body1" paragraph>
          {strings["protect.section.3.p.5"]}&nbsp;
          <Box fontWeight="fontWeightBold" component="span">
            <Link component={RouterLink} to="/terms">
              {strings["protect.section.3.button.terms"]}
            </Link>
          </Box>
          .
        </Typography>
      </Grid>
      <Hidden mdDown>
        <Grid item md={6}>
          <img width="100%" src="images/servicing/services.jpg" alt="servicing" />
        </Grid>
      </Hidden>
    </Grid>
  </Box>
);

const sectionFour = (classes: any) => (
  <Box>
    <Typography variant="h2">{strings["protect.section.4.header"]}</Typography>
    <Typography variant="h3" paragraph>
      {strings["protect.section.4.sub"]}
    </Typography>
    <Box textAlign="left">
      <Hidden mdDown>
        <Grid container spacing={1} justifyContent="space-between">
          <Grid item md={7}>
            <ul className={classes.listCheck}>
              {strings["protect.section.4.list.1"].map((i, index) => (
                <li key={index}>
                  <DoneIcon color="secondary" />
                  <Typography variant="body1" component="span">
                    {i}
                  </Typography>
                </li>
              ))}
            </ul>
          </Grid>
          <Grid item md={5}>
            <ul className={classes.listCheck}>
              {strings["protect.section.4.list.2"].map((i, index) => (
                <li key={index}>
                  <DoneIcon color="secondary" />
                  <Typography variant="body1" component="span">
                    {i}
                  </Typography>
                </li>
              ))}
            </ul>
          </Grid>
        </Grid>
      </Hidden>
      <Hidden lgUp>
        <Box>
          <ul className={classes.listCheck}>
            {strings["protect.section.4.list.1"].map((i, index) => (
              <li key={index}>
                <DoneIcon color="secondary" />
                <Typography variant="body1" component="span">
                  {i}
                </Typography>
              </li>
            ))}
            {strings["protect.section.4.list.2"].map((i, index) => (
              <li key={index}>
                <DoneIcon color="secondary" />
                <Typography variant="body1" component="span">
                  {i}
                </Typography>
              </li>
            ))}
          </ul>
        </Box>
      </Hidden>
    </Box>
  </Box>
);

const sectionFive = (
  <Box textAlign="center">
    <OverrideTheme>
      <QuoteGuarantee type={EQuoteType.Boiler} />
    </OverrideTheme>
  </Box>
);

export const ProtectPage = () => {
  eventAnalytic.useEffect(EEventType.PageProtectView);
  const classes = useStyles();
  let history = useHistory();

  useEffect(() => {
    return () => {
      if (history.action === "POP") {
        history.replace(history.location.pathname, {
          lastStep: true
        });
      }
    };
  }, [history]);

  const sections = (
    <Box py={3}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Container maxWidth="lg">{sectionOne}</Container>
        </Grid>
        <Grid item md={12}>
          <Container maxWidth="lg">{sectionTwo(classes)}</Container>
        </Grid>
        <Grid item md={12}>
          <Container maxWidth="lg">{sectionThree}</Container>
        </Grid>
        <Grid item md={12}>
          <Box className={classes.alternate} mb={2} py={4} textAlign="center">
            <Container maxWidth="lg">{sectionFour(classes)}</Container>
          </Box>
        </Grid>
        <Grid item md={12}>
          <Container maxWidth="lg">{sectionFive}</Container>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <React.Fragment>
      <Box className={classes.banner}>
        <Container maxWidth="lg">
          <Hidden mdDown>
            <Box textAlign="center" ml="auto" mr="5%">
              <Typography variant="h5" paragraph>
                {strings["protect.header"]}
              </Typography>
              <Typography variant="h3">
                {strings["protect.header.sub.1"]}&nbsp;
                <Typography variant="h5" component="span">
                  {strings["protect.header.sub.2"]}
                </Typography>
                &nbsp;{strings["protect.header.sub.3"]}
              </Typography>
            </Box>
          </Hidden>
        </Container>
      </Box>
      <Hidden lgUp>
        <Box textAlign="center" ml="auto">
          <Typography variant="h5">{strings["protect.header"]}</Typography>
          <Typography variant="h3">
            {strings["protect.header.sub.1"]}
            <br />
            <Typography variant="h5" component="span">
              {strings["protect.header.sub.2"]}
            </Typography>
            <br />
            {strings["protect.header.sub.3"]}
          </Typography>
        </Box>
      </Hidden>

      {sections}

      <Box className={classes.alternate} mb={2} py={4} textAlign="center">
        <OverrideTheme>
          <ReviewContainer support={true} />
        </OverrideTheme>
      </Box>
    </React.Fragment>
  );
};
